<button (click)="close()" class="modal-close"></button>

<h4
  class="modal-title"
  i18n="time zone modal@@We noticed that you have not set up a timezone yet"
>
  We noticed that you have not set up a timezone yet
</h4>

<div class="modal-content">
  <div class="modal-intro">
    <form
      class="form"
      id="dashboardForm"
      [formGroup]="timeZoneForm"
      (ngSubmit)="onSubmit()"
    >
      <ls-single-select
        [formControl]="timeZoneForm.controls['timeZone']"
        [label]="'Time Zone'"
        [items]="this.data.timeZones"
        [placeholder]="'Please select a time zone'"
      ></ls-single-select>
    </form>
  </div>
</div>

<div class="modal-footer">
  <button
    type="submit"
    class="o-button o-button--success"
    form="dashboardForm"
    i18n="Button|@@Save"
    [disabled]="!timeZoneForm || !timeZoneForm.valid"
  >
    Save
  </button>
</div>

<div id="Time Zone" i18n="@@Time Zone" ls-dynamic-translation>Time Zone</div>
<div
  id="Please select a time zone"
  i18n="time zone modal@@Please select a time zone"
  ls-dynamic-translation
>
  Please select a time zone
</div>
